import PoolAbi from '../contracts/pool.json';
import LPTokenAbi from '../contracts/LPToken.json'

export const contractInterfaces = {
    mainnet: {
        pool: {
            poolAbi: PoolAbi,
            contractAddress: "0x3003D36b5D2633057b198E4f1C4aB8498367fb03",
        },
        lpToken: {
            lpTokenAbi: LPTokenAbi,
            contractAddress: "0xdd4d2BE756af9135Adb2170788Ea748020b5Ba33"
        }
    }, 
    testnet: {
        pool: {
            poolAbi: PoolAbi,
            contractAddress: "0x7d8efEe7ffaF4078c1B6135C000D10c224619804",
        },
        lpToken: {
            lpTokenAbi: LPTokenAbi,
            contractAddress: "0x9d5b8c25c11D8dEaB6e52FB8bB6f89F3FC785De7"
        }
    }
}